module.exports = __webpack_public_path__ + "static/media/whyzodot_client.308277ea.svg";